import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";
import { useSelector } from "react-redux";
import ReactMarkdown from "react-markdown";

import { Header } from "./Header";
import { NotificationBar } from "./NotificationBar";
import { AppState } from "../store/definitions";

// Reusable renderer
const RenderContent = ({ content }: { content: string }) => {
    if (!content) return null;

    return (
        <Box
            style={{
                fontSize: "1rem",
                textAlign: "center",
            }}
        >
            <ReactMarkdown
                components={{
                    p: ({ children }) => (
                        <Text as="p" fontSize="fontSize30" marginBottom="space40">
                            {children}
                        </Text>
                    ),
                    strong: ({ children }) => (
                        <Text as="span" fontWeight="fontWeightSemibold">
                            {children}
                        </Text>
                    ),
                    a: ({ href, children }) => (
                        <a href={href} target="_blank" rel="noopener noreferrer">
                            {children}
                        </a>
                    ),
                }}
            >
                {content}
            </ReactMarkdown>
        </Box>
    );
};

export const HoopCanvasPhase = () => {
    const { message, hoopdetails } = useSelector(({ config }: AppState) => ({
        message:
            config.hoop?.hoopMessage ||
            "Our support team is currently unavailable. Please try again later.",
        hoopdetails: config.hoop?.hoopDetails || "",
    }));

    return (
        <>
            <Header />
            <NotificationBar />

            <Box
                padding="space70"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                height="100%"
                textAlign="center"
            >
                <Text as="h2" fontSize="fontSize50" marginBottom="space40">
                    Chat Currently Unavailable
                </Text>

                <Box marginBottom="space50">
                    <RenderContent content={message} />
                </Box>

                <RenderContent content={hoopdetails} />
            </Box>
        </>
    );
};